export const _setNew2284Form = (state, action) => {
  state.new2284Form = action.payload;
};

export const _setEpdIrId = (state, action) => {
  state.epdIrId = action.payload;
};

export const _setReportingProgram = (state, action) => {
  state.reportingProgram = action.payload;
};

export const _setParoleAgentOfRecord = (state, action) => {
  state.paroleAgentOfRecord = action.payload;
};

export const _setIncidentLocation = (state, action) => {
  state.incidentLocation = action.payload;
};

export const _setIncidentDate = (state, action) => {
  state.incidentDate = action.payload;
};

export const _setOrgAddress = (state, action) => {
  state.orgAddress = action.payload;
};

export const _setAdmitDate = (state, action) => {
  state.admitDate = action.payload;
};

export const _setIncidentAddress = (state, action) => {
  state.incidentAddress = action.payload;
};
export const _setIncidentTime = (state, action) => {
  state.incidentTime = action.payload;
};

export const _setCaseManagerName = (state, action) => {
  state.caseManagerName = action.payload;
};

export const _setCaseManagerTelephone = (state, action) => {
  state.caseManagerTelephone = action.payload;
};

export const _setCaseManagerEmail = (state, action) => {
  state.caseManagerEmail = action.payload;
};

export const _setDapo = (state, action) => {
  state.dapo = action.payload;
};

export const _setDhcs = (state, action) => {
  state.dhcs = action.payload;
};

export const _setDrp = (state, action) => {
  state.drp = action.payload;
};

export const _setOther = (state, action) => {
  state.other = action.payload;
};

export const _setOtherDescription = (state, action) => {
  state.otherDescription = action.payload;
};

export const _setIsContactedFire = (state, action) => {
  state.isContactedFire = action.payload;
};

export const _setIsContactedParamedics = (state, action) => {
  state.isContactedParamedics = action.payload;
};

export const _setIsContactedPolice = (state, action) => {
  state.isContactedPolice = action.payload;
};

export const _setContactedAgenciesName = (state, action) => {
  state.contactedAgenciesName = action.payload;
};

export const _setIsParoleArrested = (state, action) => {
  state.isParoleArrested = action.payload;
};

export const _setArrestingAgency = (state, action) => {
  state.arrestingAgency = action.payload;
};

export const _setArrestDate = (state, action) => {
  state.arrestDate = action.payload;
};

export const _setIsNewsMediaCoverage = (state, action) => {
  state.isNewsMediaCoverage = action.payload;
};

export const _setNewsAgency = (state, action) => {
  state.newsAgency = action.payload;
};

export const _setNewsRepNameAndPhone = (state, action) => {
  state.newsRepNameAndPhone = action.payload;
};

export const _setIsLawEnforcementContacted = (state, action) => {
  state.isLawEnforcementContacted = action.payload;
};

export const _setLawEnforcementAgency = (state, action) => {
  state.lawEnforcementAgency = action.payload;
};

export const _setIncidentDescription = (state, action) => {
  state.incidentDescription = action.payload;
};

export const _setIncidentCreateDate = (state, action) => {
  state.incidentCreateDate = action.payload;
};

export const _setIncidentCreatedBy = (state, action) => {
  state.incidentCreateDate = action.payload;
};
